<template>
  <div style="height:calc(100vh - 40px - 50px)">
    <div :id="id" style="height:100%" v-loading="loading" element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
    <!--图点击弹窗-->
    <vxe-modal v-model="dialogVisible" :title="dialogtitle" width="800px" show-zoom resize transfer destroy-on-close
      :position="{ top: '20%' }" draggable>

      <div style="max-height: 60vh" v-if="dialogtitle == '信披事件'">
        <v-card>
          <v-list dense two-line v-loading="requestLoading">
            <v-list-item v-for="(item, index) in curEvents">
              <v-list-item-content>
                <v-list-item-title>{{ "名称：" + item.eventName }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  "时间：" + $func.formatDate(item.eventTime, "yyyy-MM-DD HH:mm:ss")
                }}</v-list-item-subtitle>
                <v-divider></v-divider>
              </v-list-item-content>
              <div>
                <v-btn text small color="primary" @click="btnOpenAnnounce(item)">
                  查看
                </v-btn>
                <v-btn text small color="primary" @click="btnxinpiIntenRead(item)">
                  小智解读
                </v-btn>
                <!-- <v-btn color="primary" text small>
                  小智分析
                </v-btn> -->
              </div>
            </v-list-item>
          </v-list>
        </v-card>
      </div>

      <div style="max-height: 60vh" v-if="dialogtitle == '本地资料'">

        <v-card v-if="!localisForder">
          <v-list dense two-line v-loading="requestLoading">
            <v-list-item v-for="(item, index) in localfileData">
              <v-list-item-content>
                <v-list-item-title>{{ "名称：" + item.eventName }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  "时间：" + $func.formatDate(item.eventTime, "yyyy-MM-DD HH:mm:ss")
                }}</v-list-item-subtitle>
                <v-divider></v-divider>
              </v-list-item-content>
              <div>
                <v-btn text small color="primary" @click="btnOpenAnnounce(item)">
                  查看
                </v-btn>
                <v-btn text small color="primary" @click="btnxinpiIntenRead(item, 'local', 'read')">
                  小智解读
                </v-btn>
                <!-- <v-btn color="primary" text small>
                  小智分析
                </v-btn> -->
                <v-btn color="primary" text small @click="btnxinpiIntenRead(item, 'local', 'learn')">
                  小智学习
                </v-btn>
                <v-btn color="error" text small @click="btnDeleteLocalFile(item, 'file')">
                  删除
                </v-btn>
              </div>
            </v-list-item>
          </v-list>
        </v-card>

        <v-card v-if="localisForder">
          <v-treeview v-loading="requestLoading" dense open-all :items="localFolderData" activatable item-key="name"
            open-on-click>
            <template v-slot:prepend="{ item, open }">
              <v-icon v-if="item.folder">
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
              </v-icon>
              <v-icon v-else>
                {{ item.icon }}
              </v-icon>
            </template>
            <template v-slot:append="{ item, leaf }">
              <div v-if="item.path">
                <v-btn text small color="primary" @click="btnOpenAnnounce(item)">
                  查看
                </v-btn>
                <v-btn text small color="primary" @click="btnxinpiIntenRead(item, 'local', 'read')">
                  小智解读
                </v-btn>
                <!-- <v-btn color="primary" text small>
                  小智分析
                </v-btn> -->
                <v-btn color="primary" text small @click="btnxinpiIntenRead(item, 'local', 'learn')">
                  小智学习
                </v-btn>
                <v-btn color="error" text small @click="btnDeleteLocalFile(item, 'Forder')">
                  删除
                </v-btn>
              </div>
              <div v-else>
                <v-btn color="error" text small @click="btnDeleteLocalForder(item)">
                  删除
                </v-btn>
              </div>

            </template>
          </v-treeview>
        </v-card>


      </div>
      <!--情报详情-->
      <div style="max-height: 60vh" v-if="dialogtitle == '情报中心'">
        <v-card>
          <v-list dense v-loading="requestLoading">
            <v-list-item v-for="(item, index) in curEvents">
              <v-list-item-content>
                <v-list-item-title style="text-overflow: inherit; white-space: inherit">{{
                  "名称：" + item.eventName
                }}</v-list-item-title>
                <v-list-item-subtitle style="text-overflow: inherit; white-space: inherit">{{ "详情：" + item.brief
                }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{
                  "时间：" + $func.formatDate(item.eventTime, "yyyy-MM-DD HH:mm:ss")
                }}</v-list-item-subtitle>

                <v-card-actions style="border-bottom: solid 1px #DCDFE6;">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text small @click="btntuili">
                    推理图谱
                  </v-btn>
                  <v-btn text small color="primary" @click="btnxinpiIntenRead(item)">
                    小智解读
                  </v-btn>
                  <!-- <v-btn color="primary" text small>
                    小智分析
                  </v-btn> -->
                </v-card-actions>

              </v-list-item-content>
            </v-list-item>
          </v-list>

        </v-card>
      </div>
      <!--市场声音-->
      <div style="max-height: 60vh" v-if="dialogtitle == '市场声音'">
        <v-card>
          <v-list dense v-loading="requestLoading">
            <v-list-item v-if="item.cata == 'hudongyi'" v-for="(item, index) in curEvents">
              <v-list-item-content>
                <v-list-item-title style="text-overflow: inherit; white-space: inherit;white-space:pre-wrap;">{{
                  "类型：互动易"
                }}</v-list-item-title>
                <v-list-item-title style="text-overflow: inherit; white-space: inherit">{{
                  "名称：" + item.bizType
                }}</v-list-item-title>
                <v-list-item-subtitle style="text-overflow: inherit; white-space: inherit;white-space:pre-wrap;">{{
                  item.eventName.match(/(\S*)答：/)[1]
                }}</v-list-item-subtitle>
                <v-list-item-subtitle style="text-overflow: inherit; white-space: inherit;white-space:pre-wrap;">{{ "答：" +
                  item.eventName.match(/答：(\S*)/)[1]
                }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{
                  "时间：" + $func.formatDate(item.eventTime, "yyyy-MM-DD HH:mm:ss")
                }}</v-list-item-subtitle>

                <v-card-actions style="border-bottom: solid 1px #DCDFE6;">
                  <v-spacer></v-spacer>
                  <v-btn text small color="primary" @click="btnlawsxinpiIntenRead(item)">
                    小智解读
                  </v-btn>
                  <!-- <v-btn color="primary" text small>
                    小智分析
                  </v-btn> -->
                </v-card-actions>

              </v-list-item-content>

            </v-list-item>
            <v-list-item v-if="item.cata == 'study_report'" v-for="(item, index) in curEvents">
              <v-list-item-content>
                <v-list-item-title style="text-overflow: inherit; white-space: inherit">{{
                  "类型：公司研报"
                }}</v-list-item-title>
                <v-list-item-title style="text-overflow: inherit; white-space: inherit">{{
                  "名称：" + item.eventName
                }}</v-list-item-title>
                <v-list-item-title style="text-overflow: inherit; white-space: inherit">{{
                  "机构：" + item.repoetUser
                }}</v-list-item-title>
                <v-list-item-subtitle style="text-overflow: inherit; white-space: inherit;white-space:pre-wrap;">
                  <span>摘要：</span>
                  <span> {{ item.brief != undefined ? item.brief : ''
                  }}</span></v-list-item-subtitle>
                <v-list-item-subtitle>{{
                  "时间：" + $func.formatDate(item.eventTime, "yyyy-MM-DD HH:mm:ss")
                }}</v-list-item-subtitle>

                <v-card-actions style="border-bottom: solid 1px #DCDFE6;">
                  <v-spacer></v-spacer>
                  <v-btn text small color="primary" @click="btnlawsxinpiIntenRead(item)">
                    小智解读
                  </v-btn>
                  <!-- <v-btn color="primary" text small>
                    小智分析
                  </v-btn> -->
                </v-card-actions>

              </v-list-item-content>
            </v-list-item>

          </v-list>
        </v-card>
      </div>



      <!--监管事件-->
      <div style="max-height: 60vh" v-if="dialogtitle == '监管事件'">
        <v-card>
          <v-list dense v-loading="requestLoading">
            <v-list-item v-for="(item, index) in curEvents">
              <v-list-item-content>
                <v-list-item-title style="text-overflow: inherit; white-space: inherit">{{
                  "名称：" + item.brief
                }}</v-list-item-title>
                <v-list-item-title style="text-overflow: inherit; white-space: inherit">{{
                  "类型：" + item.eventName
                }}</v-list-item-title>
                <v-list-item-title style="text-overflow: inherit; white-space: inherit">{{
                  "机构：" + item.GE8000090E + "-" + item.bizType
                }}</v-list-item-title>


                <v-list-item-subtitle style="text-overflow: inherit; white-space: inherit;white-space:pre-wrap;">{{ "摘要："
                  + item.GE8000093E
                }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{
                  "时间：" + $func.formatDate(item.eventTime, "yyyy-MM-DD HH:mm:ss")
                }}</v-list-item-subtitle>

                <v-card-actions style="border-bottom: solid 1px #DCDFE6;">
                  <v-spacer></v-spacer>
                  <v-btn v-if="item.reportId" text small color="primary" @click="btnOpenAnnounce(item)">
                    原文
                  </v-btn>
                  <v-btn text small color="primary" @click="btnlawsxinpiIntenRead(item)">
                    小智解读
                  </v-btn>
                  <!-- <v-btn color="primary" text small>
                    小智分析
                  </v-btn> -->
                </v-card-actions>

              </v-list-item-content>
            </v-list-item>
          </v-list>

        </v-card>
      </div>

      <!--运营事件-->
      <div style="max-height: 60vh" v-if="dialogtitle == '运营事件'">
        <v-card>
          <v-list dense v-loading="requestLoading">
            <v-list-item v-for="(item, index) in curEvents">
              <v-list-item-content>
                <v-list-item-title style="text-overflow: inherit; white-space: inherit">{{
                  "名称：" + item.bizType
                }}</v-list-item-title>
                <v-list-item-subtitle style="text-overflow: inherit; white-space: inherit">{{ "详情：" + item.eventName
                }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{
                  "时间：" + $func.formatDate(item.eventTime, "yyyy-MM-DD HH:mm:ss")
                }}</v-list-item-subtitle>

                <v-card-actions style="border-bottom: solid 1px #DCDFE6;">
                  <v-spacer></v-spacer>
                  <v-btn text small color="primary" @click="btnxinpiIntenRead(item)">
                    小智解读
                  </v-btn>
                  <!-- <v-btn text small color="primary">
                    小智分析
                  </v-btn> -->
                </v-card-actions>

              </v-list-item-content>
            </v-list-item>
          </v-list>

        </v-card>
      </div>

      <!--工商事件-->
      <div style="max-height: 60vh" v-if="dialogtitle == '工商事件'">
        <v-card>
          <v-list dense v-loading="requestLoading">
            <v-list-item v-for="(item, index) in curEvents">
              <v-list-item-content>
                <v-list-item-title style="text-overflow: inherit; white-space: inherit">{{
                  "名称：" + item.bizType
                }}</v-list-item-title>
                <v-list-item-subtitle style="text-overflow: inherit; white-space: inherit">{{ "详情：" + item.eventName
                }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{
                  "时间：" + $func.formatDate(item.eventTime, "yyyy-MM-DD HH:mm:ss")
                }}</v-list-item-subtitle>

                <v-card-actions style="border-bottom: solid 1px #DCDFE6;">
                  <v-spacer></v-spacer>
                  <v-btn text small color="primary" @click="btnxinpiIntenRead(item)">
                    小智解读
                  </v-btn>
                  <!-- <v-btn text small color="primary">
                    小智分析
                  </v-btn> -->
                </v-card-actions>

              </v-list-item-content>
            </v-list-item>
          </v-list>

        </v-card>
      </div>

    </vxe-modal>
  </div>
</template>

<script>
import * as vega from "vega";
import apiAxios from "@/config/apiAxios";
import userDocApi from "@/assets/js/userDocApi";
import vegaDefaultConfig from "./decisionVegaDefaultConfig.json"
import XEUtils from 'xe-utils'
export default {
  name: "decision",
  props: {
    id: {
      type: String,
      required: true,
      default: "",
    },
    eid: {
      type: String,
      required: true,
      default: "",
    },
    companyfullName: {
      type: String,
      required: true,
      default: "",
    },
  },
  data() {
    return {
      vegaView: false,
      loading: false,
      dialogtitle: "信披详情",
      dialogVisible: false,
      curEvents: [],
      dialogJsonformstitle: "",
      pbcid: "",
      // companyfullName: "",
      isnow: 'now',
      requestLoading: false,
      vegaDefaultConfig: vegaDefaultConfig,
      localfileList: [],
      localfileData: [],
      localFolderData: [],
      localTab: "localfile",
      localisForder: false,
      noargrevongType: ""

    };
  },
  methods: {
    changeEid(eid) {

      this.vegaView.signal('selectedEid', eid).data('industry', []).data('annt', [])
        .data('intel', []).data('hudongyi', []).data('laws', []).data('operational', [])
        .data('stock', []).data('local', []).data('cmdp', []).run()
      this.getVegaData();
    },
    vegaInit() {
      let width = document.getElementById(this.id).clientWidth;
      let height = document.getElementById(this.id).clientHeight;

      this.vegaDefaultConfig.width = width;
      this.vegaDefaultConfig.height = height;
      this.vegaDefaultConfig.signals[0].value = this.eid;
      let aa = vega.parse(this.vegaDefaultConfig);
      var view = new vega.View(vega.parse(this.vegaDefaultConfig))
        .renderer("svg")
        .initialize("#" + this.id)
        .hover()
        .run();
      let that = this;
      view.addEventListener("click", function (event, item) {
        if (!item) {
          return;
        }
        if (
          item.datum.typeZh == "信披事件" ||
          item.datum.typeZh == "情报中心" ||
          item.datum.typeZh == "本地资料" ||
          item.datum.typeZh == '市场声音' || item.datum.typeZh == '运营事件'
          || item.datum.typeZh == '监管事件' || item.datum.typeZh == '工商事件'

        ) {
          that.isnow = item.datum.timebin;
          that.curEvents = item.datum.events;
          if (item.datum.typeZh == "本地资料") {
            that.localisForder = item.datum.isForder
            that.localfileData = [];
            that.localfileList = XEUtils.clone(item.datum.events, true);
            that.localfileData = item.datum.events;
            if (item.datum.isForder) {
              let folderlist = item.datum.events;
              if (folderlist.length > 0) {
                that.localFolderData = that.buildForder(folderlist)

              }
            }
          }
          that.dialogtitle = item.datum.typeZh;
          that.dialogVisible = true;
        } else if (item.datum.bizType == "widget") {
          if (item.datum.eventName == '资本市场全景') {
            let newLink = window.open('', '_blank');
            let newUrl = that.$router.resolve({
              path: '/bigScreen',
            });
            newLink.location.href = newUrl.href;
            return
          }
          that.dialogJsonformstitle = item.datum.eventName;
          that.getProFileInfo(item.datum.tags);
        } else if (item.datum.bizType == 'app_vega') {
          that.runVega(item.datum)
        } else if (item.datum.bizType == 'app_esg') {
          that.$EventBus.$emit("opendialogkanBoard", {
            _params: {
              dialogtitle: "ESG看板",
              dialogWidth: "80vw",
              kanboardtype: "ESG"
            }
          })
          // that.showTpl(item.datum)
        }
        else if (!item.datum.typeZh && item.text) {
          if (item.text.indexOf("盘点历史") > -1) {
            that.$EventBus.$emit("opendialogChangeVega", {
              _params: {
                dialogtitle: "重大事件评定标准",

              }
            })

          } else {
            that.$notify({ type: "info", message: "筛选功能开发中......" });
          }
          // alert('筛选')
        }
      });
      view.addEventListener("touchstart", function (event, item) {
        if (!item) {
          return;
        }
        if (
          item.datum.typeZh == "信披事件" ||
          item.datum.typeZh == "情报中心" ||
          item.datum.typeZh == "本地资料" ||
          item.datum.typeZh == '市场声音' || item.datum.typeZh == '运营事件'
          || item.datum.typeZh == '监管事件' || item.datum.typeZh == '工商事件'

        ) {
          that.isnow = item.datum.timebin;
          that.curEvents = item.datum.events;
          if (item.datum.typeZh == "本地资料") {
            that.localisForder = item.datum.isForder;
            that.localfileList = XEUtils.clone(item.datum.events, true);
            that.localfileData = [];
            that.localfileData = item.datum.events;
            if (item.datum.isForder) {
              let folderlist = item.datum.events;
              if (folderlist.length > 0) {
                that.localFolderData = that.buildForder(folderlist)

              }
            }
          }
          that.dialogtitle = item.datum.typeZh;
          that.dialogVisible = true;
        } else if (item.datum.bizType == "widget") {
          if (item.datum.eventName == '资本市场全景') {
            let newLink = window.open('', '_blank');
            let newUrl = that.$router.resolve({
              path: '/bigScreen',
            });
            newLink.location.href = newUrl.href;
            return
          }
          that.dialogJsonformstitle = item.datum.eventName;
          that.getProFileInfo(item.datum.tags);
        } else if (item.datum.bizType == 'app_vega') {
          that.runVega(item.datum)
        } else if (item.datum.bizType == 'app_esg') {
          //that.showTpl(item.datum)
          that.$EventBus.$emit("opendialogkanBoard", {
            _params: {
              dialogtitle: "ESG看板",
              dialogWidth: "80vw",
              kanboardtype: "ESG"
            }
          })
        }
        else if (!item.datum.typeZh && item.text) {
          that.$notify({ type: "info", message: "筛选功能开发中......" });
          // alert('筛选')
        }
      })
      that.vegaView = view;
      that.getVegaData();

    },
    buildForder(data) {

      let result = [];
      let folderName = XEUtils.pluck(data, 'folderName');
      let uniq = XEUtils.uniq(folderName);
      // 构建floder父级
      uniq.map(function (d) {
        if (d.indexOf('/') == -1) {
          // 父，只有名字
          result.push({ name: d, id: d, folder: true })
        } else {
          let aa = d.split('/');
          let _folderName = aa.slice(0, aa.length - 1).join('/');
          result.push({ name: d, id: d, parentId: _folderName, folder: true })
        }

      })
      let files = {
        html: 'mdi-language-html5',
        js: 'mdi-nodejs',
        json: 'mdi-code-json',
        md: 'mdi-language-markdown',
        pdf: 'mdi-file-pdf',
        png: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
        xlsx: 'mdi-file-excel',
        doc: 'mdi-file-word',
        docx: 'mdi-file-word',
      };
      data.map(function (d) {
        let exEnd = d.eventName.split('.').pop();
        d.parentId = d.folderName;
        d.id = d.fid;
        d.name = d.eventName;
        d.icon = files[exEnd]
        result.push(d)
      })

      let aaa = XEUtils.toArrayTree(result, {
        parentKey: "parentId",
        key: 'id'
      })
      return aaa;

    },

    getVegaData() {
      //  this.vegaView.signal("selectedEid", this.eid);
      this.getanntData();// 信披数据
      // this.getindustryData();// 工商数据
      // this.getLocalData(); // 本地资料
      this.getPanJson('industry', 'GM00012719.json');// 工商数据
      this.getPanJson('intel', 'GM00012324.json');//获取情报数据
      // this.getPanJson('hudongyi', 'GM00012885.json');//获取市场声音-互动易数据
      // this.getPanJson('study_report', 'GM00013898.json');//获取市场声音-公司研报事件数据
      this.getvocData();
      this.getPanJson('laws', 'GM00012644.json');//获监管事件数据
      this.getPanJson('operational', 'GM00012591.json');//获监运营事件数据
      // this.getPanJson('stock', 'GM00008243.json');//获监股票数据
      this.getCMDPData(); // 获取cmdp数据
      // this.getBondData();// 获取债券数据
    },
    // 获取信披公告数据
    getanntData() {
      let url = `${config.serverUrl}/basiceg/v1/data/base/ld_apis`
      let _params =
      {
        "LD": {
          "api": "http://lana.cmdp.cn/basiceg/v1/thdb/announcements/LR_TH_COMPANY_EVENT_VIEW/",
          "eids": [
            this.eid
          ]
        }
      }

      apiAxios.post(url, _params, _r => {
        // this.getindustryData();
        if (_r["LD"]) {
          this.vegaView.data("annt", _r["LD"]).run();
          // this.$refs.myvegaView.updateVega([], _r["LD"], this.eid, this.fullName, [], [],[]);
        }
      })


    },
    // 获取公商数据
    getindustryData() {

      let url1 = `${config.serverUrl}/cmds/v1/company/info-rest/custom?name=${this.companyfullName}&api=p_changes`
      apiAxios.get(url1, {}, _r1 => {
        // this.getintelData();
        if (_r1.p_changes) {
          this.vegaView.data("industry", _r1.p_changes).run();

        }
      })
    },

    // 获取情报数据、市场声音数据、运营事件、法律诉讼事件、工商变动事件
    getPanJson(type, fileName) {
      let path = `usys/cmdw/${this.eid}/${fileName}`;
      userDocApi.getBoardConf(path, _r => {
        if (_r.code == 404) {

        } else {
          this.vegaView.data(type, Object.values(_r)[0]).run();
        }
      })
    },
    // 获取市场声音数据，包括 互动易和公司研报数据
    getvocData() {
      let vocData = []
      let path1 = `usys/cmdw/${this.eid}/GM00012885.json`
      let path2 = `usys/cmdw/${this.eid}/GM00013898.json`
      userDocApi.getBoardConf(path1, _r => {
        if (_r.code == 404) {

        } else {
          let aa = Object.values(_r)[0];
          aa.map(function (d) {
            d.cata = 'hudongyi'
            vocData.push(d);
          })
        }
        userDocApi.getBoardConf(path2, _r1 => {
          if (_r1.code == 404) {

          } else {
            let bb = Object.values(_r1)[0];
            bb.map(function (d) {
              d.cata = 'study_report'
              vocData.push(d);
            })
            // this.vegaView.data(type, Object.values(_r)[0]).run();
          }
          if (vocData.length > 0) {
            this.vegaView.data('hudongyi', vocData).run();
          }
        })
      })

    },
    // 获取债券数据，包括 银行间和上市板块
    getBondData() {
      let bondData = []
      let path1 = `usys/cmdw/${this.eid}/GM00009049.json`
      let path2 = `usys/cmdw/${this.eid}/GM00009030.json` //银行间
      userDocApi.getBoardConf(path1, _r => {
        if (_r.code == 404) {

        } else {
          let aa = Object.values(_r)[0];
          aa.map(function (d) {
            d.cata = 'hudongyi'
            bondData.push(d);
          })
        }
        userDocApi.getBoardConf(path2, _r1 => {
          if (_r1.code == 404) {

          } else {
            let bb = Object.values(_r1)[0];
            bb.map(function (d) {
              d.cata = 'study_report'
              bondData.push(d);
            })
            // this.vegaView.data(type, Object.values(_r)[0]).run();
          }
          if (bondData.length > 0) {
            this.vegaView.data('bond', bondData).run();
          }
        })
      })
    },
    // 获取cmdp数据
    getCMDPData() {
      let params = {
        //   "userId": this.userInfo._id,  //可以不用传，接口会自动增加uid参数
        "tags": ["tech_sbom", "prod_base_financing_risk,prod_base_tax_risk,prod_base_first_enterprise,prod_base_parodyAnn,genesys_rule_001,prod_cmdp_plus_recommend,prod_cmdp_plus_predict,prod_cmdp_plus_assist"],
        "filter": "'fileInfo.extends.resource.delStatus' eq 1  and 'fileInfo.extends.resource.type' eq '1'"
      }
      apiAxios.apmSyncPost('tool_box_list_00001', params, {}, _r => {
        if (_r.code == 200) {
          let resdata = _r.data.data || [];
          if (resdata.length <= 0) {
            return;
          }
          let cmdpdata = [{

            "eventName": "资本市场全景",
            "bizType": "widget",
            "widgetId": "资本市场全景",
            "tags": ["prod_base_cmpv"]
          }, {

            "eventName": "利润操纵风险测评",
            "bizType": "app_vega",
            "widgetId": "利润操纵风险测评",
            "appId": "brain",
            "tags": ["genesys_rule_001"]
          },
          {

            "eventName": "ESG透视图",
            "bizType": "app_esg",
            "widgetId": "ESG透视图",
            "appId": "api000161",
            "tags": ["genesys.GM00014165_LDM"]
          }
          ]
          resdata.map(function (d) {
            let obj = { "bizType": "widget" }
            obj.eventName = d.name;
            obj.widgetId = d.name;
            obj.tags = Object.keys(d.tags);
            cmdpdata.push(obj)
          });

          this.vegaView.data('cmdp', cmdpdata);
        }
        console.log(_r);
      })
    },


    // 查找用户本地资源

    getLocalData() {
      let path = `md/cmdp专业版用户上传本地资料/${this.companyfullName}/localuploadFileInfo.json`
      userDocApi.getFileContextByPath(path, "application/json", _r => {
        // 父级目录不存在
        if (_r.code == 404) {

        } else {
          this.vegaView.data('local', _r);
        }
      })
    },

    // 更新本地数据
    updateLocal(local) {
      this.vegaView.data("local", local).run();
    },
    getTooltip(view) {
      console.log(view);
    },
    // 查看原文
    btnOpenAnnounce(item) {
      if (item.type == 2) {
        let url = `${config.serverUrl}/basiceg/v1/data/base/ld_apis`;
        let _params = {
          LD: {
            api:
              "http://lana.cmdp.cn/basiceg/v1/thdb/announcements/LR_TH_COMPANY_ANNOUNCE/",
            eids: [item.reportId],
          },
        };
        apiAxios.post(url, _params, (_r) => {
          if (_r.LD.length > 0) {
            //  let path = _r.LD[0].s3file;
            // window.open(`${config.serverUrl}/basiceg/v1/pdf/${path}`, "_blank");
            let url = _r.LD[0].fileinfo.extends.announcement.F003V;
            window.open(url, "_blank")
          }
        });
      } else if (item.type == 5 || item.type == 7) {
        window.open(item.reportId, "_blank");
      } else if (item.type == 4) {
        let userId = sessionStorage.getItem("USER_ID");
        let url = `${config.serverUrl}/cmnd/ndisk/ms/v1/file_extra/${item.path}?sourceUserId=${userId}&opUserId=${userId}`;
        window.open(url);
      }
    },
    // 查询产品文件信息
    getProFileInfo(tags) {
      let path = `usys/products/release`;
      let _params = {
        filter:
          "'fileInfo.extends.resource.delStatus' eq 1  and 'fileInfo.extends.resource.type' eq '1'",
        tags: tags,
      };
      // 获取产品信息
      userDocApi.getFileInfoList(path, _params, (_r) => {
        if (_r.code == 200) {
          if (_r.data.records.length > 0) {
            let _fileInfo = _r.data.records[0];
            this.pbcid = _fileInfo.fid;
            this.getSbomJson(_fileInfo.fileInfo.extends.resource.path);
          } else {
            this.$notify({ type: "danger", message: "您暂未订阅该智库，请联系客户经理" });
          }
        } else {
          this.$notify({ type: "danger", message: "获取智库信息失败" });
        }
        //
      });
    },
    // 获取产品sbom 文件内容
    getSbomJson(path) {
      userDocApi.getBoardConf(path, (_r) => {
        if (_r.resources) {
          let jsonSchemaPath = _r.resources.filter((x) => x.type == "ui")[0];
          if (jsonSchemaPath) {
            this.getSchemaData(jsonSchemaPath.uri);
          }
          console.log(jsonSchemaPath);
        }
        // console.log(_r);
      });
    },
    getSchemaData(path) {
      userDocApi.getBoardConf(path, (_r) => {
        if (_r.code == 404) {
        } else {
          let _params = {
            detail: _r,
            dialogtitle: this.dialogJsonformstitle,
            pbcid: this.pbcid,
          };
          this.$EventBus.$emit("opendialogJsonForms", { _params: _params });
        }
        console.log(_r);
      });
    },
    //本地资料精读按钮
    btnLocalIntenRead(item) {
      let path = `usys/products/release`;
      let _params = {
        filter:
          "'fileInfo.extends.resource.delStatus' eq 1  and 'fileInfo.extends.resource.type' eq '1'",
        tags: ["prod_base_recog"],
      };
      // 获取产品信息
      userDocApi.getFileInfoList(path, _params, (_r) => {
        if (_r.code == 200) {
          if (_r.data.records.length > 0) {
            let _fileInfo = _r.data.records[0];
            let lastIndex = item.path.lastIndexOf("/");
            let filePath = item.path.slice(0, lastIndex);
            //  this.pbcid = _fileInfo.fid;
            this.pbcRun(_fileInfo.fid, filePath, item.fid);
            //  this.getSbomJson(_fileInfo.fileInfo.extends.resource.path)
          } else {
            this.$notify({ type: "danger", message: "您暂未订阅该智库，请联系客户经理" });
          }
        } else {
          this.$notify({ type: "danger", message: "获取智库信息失败" });
        }
        //
      });
      // 查询无参识别产品
    },
    /**监管事件解读 */
    btnlawsxinpiIntenRead(item) {
      let fileName = "", fileContent = "";
      if (item.typeZh == "监管事件") {
        if (!item.GE8000093E || item.GE8000093E == "暂无简介" || item.GE8000093E =="") {
          this.$notify({ type: "warning", message: "摘要内容无法解读" })
          return;
        }
        fileName=item.brief+".txt";
        fileContent=item.GE8000093E;
      }
      if(item.typeZh=="市场声音"){
        if(item.cata=="hudongyi"){
          if(!item.eventName || item.eventName==""){
            this.$notify({ type: "warning", message: "内容无法解读" })
           return;
          }
          fileName="互动易问答"+ $func.formatDate(item.eventTime, "yyyy-MM-DD HH:mm:ss")+".txt";
          fileContent=item.eventName;
        }
        if(item.cata=="study_report"){
          if(!item.brief || item.brief==""){
            this.$notify({ type: "warning", message: "摘要内容无法解读" });
            return;
          }
          fileName="公司研报"+ $func.formatDate(item.eventTime, "yyyy-MM-DD HH:mm:ss")+".txt";
          fileContent=item.brief;
        }
      }
      
      this.txtFileIntenRead(fileName, fileContent)



    },

    /**txt文字转为文件上传解读 */
    txtFileIntenRead(fileName, fileContent) {
      // let fileName=item.brief+".txt";
      let FileData = new File([fileContent], fileName);
      let fileParam = {
        content: FileData,
        label: fileName,
        name: fileName
      };
      this.requestLoading = true;
      userDocApi.createFile("md/temp", fileName, fileParam, _r => {
        if (_r.code == 200) {
          userDocApi.getFileInfoByPath(`md/temp/${fileName}`, _r1 => {
            this.requestLoading = false;
            if (_r1.code == 200) {
              let fileInfo = _r1.data;
              let _dparams = {
                dialogtitle: "小智解读", readerLabel: "小智解读",
                dialogWidth: "80vw",
                sm3: fileInfo.extends.resource.sm3,
                fileLabel: fileInfo.extends.resource.label,
                filePath: 'md/temp'
                // fileInfo:_r1.data.data
              }
              this.$EventBus.$emit('opendialogIntensive', { _params: _dparams })
            }
            //  console.log(_r1);
          })


        } else {
          this.$notify({ type: "danger", message: "摘要内容上传失败" })
        }
      })

    },

    // 执行无参识别
    pbcRun(pbcid, filePath, fileFid) {
      let schemadata = { NC3050003E: this.companyfullName, fid: filePath };
      let fromFileName = `${$func.getUUID_resource()}.json`;
      // 分开处理 schemadata 数据，将文件 和 表单数据分开
      // 文件数据
      let formFileData = new File([JSON.stringify(schemadata)], fromFileName);
      let label = `${this.companyfullName}精读_form收集数据`;
      let formfileParam = {
        content: formFileData,
        label: label,
        name: fromFileName,
      };
      userDocApi.createFile(
        "usys/products/release/cache",
        fromFileName,
        formfileParam,
        (_r1) => {
          if (_r1.code == 200) {
            // 构建资源清单
            let upjson = {
              id: $func.getUUID_resource(),
              name: "",
              desc: "精读_form收集数据",
              token:
                sessionStorage.getItem("USER_TOKEN_VAL") ||
                localStorage.getItem("USER_TOKEN_VAL"), //用户token
              category: "params",
              exteralRefs: [""],
              resources: [
                {
                  name: "inputParam",
                  type: "formfields",
                  uri: _r1.data.fid, // 数据收集，formdata fid
                },
                {
                  name: "server",
                  type: "pbc",
                  uri: pbcid, // sbom文件fid,个人目录usys/widgets/ 里面找
                },
                {
                  name: "fid",
                  type: "formfile",
                  uri: fileFid,
                  path: filePath,
                },
              ],
            };

            // 处理fid
            upjson.artifactId = `${this.companyfullName}精读_执行参数`;
            let fileName = `${upjson.id}.json`;
            let FileData = new File([JSON.stringify(upjson)], fileName);
            let fileParam = {
              content: FileData,
              label: upjson.name,
              name: fileName,
            };
            console.log("_r");

            userDocApi.createFile(
              "usys/products/release/cache",
              fileName,
              fileParam,
              (_r) => {
                if (_r.code == 200) {
                  // 执行规则表
                  let fid = _r.data.fid;
                  let eventsource = `${window.eventkey}_${pbcid}`;
                  let _param = {
                    fid: fid,
                    ruleApiNumber: "api000145",
                    token:
                      sessionStorage.getItem("USER_TOKEN_VAL") ||
                      localStorage.getItem("USER_TOKEN_VAL"),
                    sseKey: window.sseKey,
                    eventsource: eventsource,
                  };
                  apiAxios.apmASyncPost("api000145", _param, {}, (res) => {
                    this.isdebug = false;
                    if (res.code == 200) {
                      this.$notify({
                        type: "success",
                        message:
                          "产品执行中，大概花5-10分钟，您可以关闭当前界面，进行其他操作，执行结果将通知您",
                      });
                    } else {
                      this.$notify({ type: "danger", message: "执行失败！" });
                    }
                  });
                } else {
                  this.$notify({ type: "danger", message: "上传参数资源清单文件失败！" });
                }
                // console.log(_r);
              }
            );
          } else {
            this.$notify({ type: "danger", message: "上传表单文件失败！" });
          }
        }
      );
    },
    // 情报推理
    btntuili(item) {


    },
    // 现在信披事件精读
    btnxinpiIntenRead(item, type = '', source = '') {

      this.noargrevongType = source
      // let fileLabel=""
      // 远程文件，去查找
      if (type == '') {
        this.requestLoading = true;
        let url = `${config.serverUrl}/basiceg/v1/data/base/ld_apis`;
        let _params = {
          LD: {
            api:
              "http://lana.cmdp.cn/basiceg/v1/thdb/announcements/LR_TH_COMPANY_ANNOUNCE/",
            eids: [item.reportId],
          },
        };
        apiAxios.post(url, _params, (_r) => {
          this.requestLoading = false;
          if (_r.LD.length > 0) {
            let fileInfo = _r.LD[0].fileinfo;
            let sm3 = fileInfo.sm3
            let params = {
              "_data": {
                sm3: sm3,
                sseKey: window.sseKey
              }
            }
            let _dparams = {
              dialogtitle: "小智解读", readerLabel: "小智解读",
              dialogWidth: "80vw",
              sm3: sm3,
              fileLabel: item.eventName,
              filePath: "md/temp"
              // fileInfo:_r1.data.data
            }
            this.$EventBus.$emit('opendialogIntensive', { _params: _dparams })
            // apiAxios.apmSyncPost("api000346",params,{},_r1=>{
            //   this.requestLoading=false;
            //   if(_r1.code==200){
            //     if(_r1.data.code==200){
            //     let _dparams={
            //     dialogtitle:"小智解读",readerLabel:"小智解读",
            //     dialogWidth:"100vw", 
            //     fileInfo:_r1.data.data
            //     }
            //     this.$EventBus.$emit('opendialogIntensive', { _params: _dparams })
            //   }else{
            //     this.$notify({ type: "danger", message: "执行小智解读失败" });
            //   }

            //   }
            //   console.log(_r1);
            // })

            // let path = _r.LD[0].s3file;
            // let lastIndex = path.lastIndexOf("/");
            // let fileName = path.slice(lastIndex + 1, path.length);
            // this.getxinpiIntenRead(item.eid, fileName, '')
          } else {
            this.$notify({ type: "danger", message: "获取公告信息失败" });
          }
        });
      } else if (type == 'local') {
        // 本地资料，直接取path
        let fileType = item.path.substring(item.path.lastIndexOf(".")).toLowerCase();
        let acceptType = [".pdf", '.txt', '.doc', '.docx']
        if (acceptType.indexOf(fileType) > -1) {
          this.requestLoading = true;
          let url = `${config.serverUrl}/cmnd/ndisk/ms/v1/info/${item.path}`
          apiAxios.get(url, {}, _r => {
            this.requestLoading = false;
            if (_r.code == 200) {
              let lastIndex = item.path.lastIndexOf("/");
              let filePath = item.path.slice(0, lastIndex);
              let sm3 = _r.data.extends.resource.sm3
              let fileLabel = _r.data.extends.resource.label;
              let _dparams = {
                dialogtitle: "小智解读", readerLabel: "小智解读",
                dialogWidth: "80vw",
                sm3: sm3,
                fileLabel: fileLabel,
                filePath: filePath
                // fileInfo:_r1.data.data
              }
              this.$EventBus.$emit('opendialogIntensive', { _params: _dparams })

            } else {
              this.$notify({ type: "danger", message: "获取文件信息失败" });
            }
          })


        } else {
          this.$notify({ type: "warning", message: "暂不支持该类文件的解读" });
        }


        // console.log(item)
        // this.requestLoading = true;


      }
    },
    // 获取
    getxinpiIntenRead(eid, filename, pdf_path) {
      // this.$EventBus.$emit("opendialogPDFReader")
      // return;
      let _param = {
        "eid": eid,
        "file_name": filename,
        'file_path': pdf_path
      }
      let ruleId = "no_arg_recognize";
      if (this.noargrevongType == 'learn') {
        ruleId = "no_arg_recognize2"
      }
      apiAxios.apmASyncPost(ruleId, _param, {}, _r => {

        if (_r.code == 200) {
          this.getApmTask(_r.data.taskId, "getxinpiIntenRead");

        }

        else {

          this.$notify({ type: "danger", message: "执行精读接口失败" });
        }
        // console.log('111')
      })

    },

    // 小智学习
    getLearnRead() {

    },

    // 获取异步任务查询
    getApmTask(taskId, typename) {
      apiAxios.apmAsyncResult(taskId, {}, (_r) => {
        if (_r.data?.taskStatus == 1) {
          window.setTimeout(() => this.getApmTask(taskId, typename), 3000);
        } else if (_r.data?.taskStatus == 11 && _r?.data?.taskResponse) {
          this.requestLoading = false;
          let _response = JSON.parse(_r.data.taskResponse);
          if (_response?.code == "200" && _response?.data?.result?.code != "500") {
            let _fileInfo = _response?.data?.result;
            if (_fileInfo.code != 200) {
              this.$notify({ type: "danger", message: "获取数据失败" });
              return;
            }
            if (typename == "getxinpiIntenRead") {
              let _data = _fileInfo.data;
              let pre_url = `${config.serverUrl}/cmnd/ndisk/ms/v1/file_download/`
              if (_data.contentType == 'pdfRead') {
                let _params = {
                  pdfUrl: `${pre_url}${_data.filePath}`,
                  ctxUrl: `${pre_url}${_data.ctxPath}`,
                  dialogtitle: this.noargrevongType == 'learn' ? '小智学习' : "小智解读"
                };
                this.$EventBus.$emit("opendialogPDFReader", { _params: _params });
              } else if (_data.contentType == 'IdentityRead') {
                let datas_obj = {};
                let fileresource = _data?.extends?.resource;
                let readerLabel = ""
                if (fileresource) {
                  readerLabel = fileresource.label;
                }
                let output = _data?.extends?.output || {};
                let outputKeys = Object.keys(output).forEach(item => {
                  if (item.indexOf("cat_std") != -1) {
                    datas_obj.cat_sys = {
                      "extends": {
                        "resource": {
                          "path": output[item].path
                        }
                      }
                    };
                  } else if (item.indexOf("cat_chapter") != -1) {
                    datas_obj.cat_sys_chapter = {
                      "extends": {
                        "resource": {
                          "path": output[item].path
                        }
                      }
                    };
                  } else if (item.indexOf("ctx_") != -1) {
                    datas_obj.ctx_sys_json = {
                      "extends": {
                        "resource": {
                          "path": output[item].path
                        }
                      }
                    };

                  } else if (item.indexOf("cat_html") != -1) {
                    datas_obj.cat_sys_html = {
                      "extends": {
                        "resource": {
                          "path": output[item].path
                        }
                      }
                    };

                  } else if (item.indexOf("audit_") != -1) {
                    datas_obj.audit_09_json = {
                      "extends": {
                        "resource": {
                          "path": output[item].path
                        }
                      }
                    };
                  } else if (item.indexOf("ver_") != -1 || item.indexOf("vern_") != -1 || item.indexOf("vera_") != -1 || item.indexOf("verc_") != -1) {
                    datas_obj.audit_01_json = {
                      "extends": {
                        "resource": {
                          "path": output[item].path
                        }
                      }
                    };
                  }

                })
                let _params = {
                  datas_obj: datas_obj, rstFileInfo: _data, dialogtitle: this.noargrevongType == 'learn' ? '小智学习' : "小智解读",
                  readerLabel: this.noargrevongType == 'learn' ? '小智学习-' + readerLabel : "小智解读-" + readerLabel, type: this.noargrevongType == 'learn' ? "distinguish" : 'intp'
                }
                this.$EventBus.$emit("opendialogCmdpReader", { _params: _params })
              }
            }
          } else {
            this.$notify({ type: "danger", message: "获取数据失败" });
          }
        } else {
          this.requestLoading = false;
          this.$notify({ type: "danger", message: "获取数据失败" });
        }

      });
    },

    // 执行弹出 vega
    runVega(item) {
      let _params =
      {
        appId: item.appId,
        eid: this.eid,
        tags: item.tags
      };
      let runloading = this.$loading({
        lock: true,
        text: '模型分析中......',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      apiAxios.apmSyncPost("DV000003", _params, {}, (_r) => {
        runloading.close();
        if (_r.code == 200) {
          if (_r.data) {
            let _params = { config: _r.data, vegaid: item.appId }
            this.$EventBus.$emit('opendialogVega', { _params: _params })
          }
        } else {
          this.$notify({ type: "danger", message: "获取数据失败" });
        }


      })


    },
    // 执行显示模板
    showTpl(item) {
      let runloading = this.$loading({
        lock: true,
        text: '处理中......',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let apiId = item.appId;
      let params = { tags: item.tags };
      apiAxios.apmSyncPost(apiId, params, {}, (_res) => {
        runloading.close();
        if (_res.code == 200) {
          let _data = _res.data;
          let datas_obj = {};

          datas_obj.cat_sys_chapter = {
            extends: {
              resource: {
                path: _data.cat_chapter,
              },
            },
          };
          datas_obj.cat_sys_html = {
            extends: {
              resource: {
                path: _data.cat_html,
              },
            },
          };
          datas_obj.ctx_sys_json = {
            extends: {
              resource: {
                path: _data.ctx_tpl,
              },
            },
          };
          datas_obj.meta_element = {
            extends: {
              resource: {
                path: _data.meta_element,
              },
            },
          };
          let ld = _data.ld;

          // datas_obj.cat_html=_data.cat_html;
          //  datas_obj.ctx_sys_json=_data.ctx_tpl;
          //   datas_obj.meta_element=_data.meta_element;
          // datas_obj.ld=_data.ld;
          let _params = {
            datas_obj: datas_obj,
            type: "profile",
            readerLabel: item.eventName,
            dialogtitle: "小智解读",
            ld: ld,
            // eid:item.eid
          };
          this.$EventBus.$emit("opendialogCmdpReader", { _params: _params });
        } else {
          this.$notify({
            type: "warn",
            message: _res.message,
          });
        }
      })
    },
    // 删除本地文件按钮
    btnDeleteLocalFile(item, type) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        XEUtils.remove(this.localfileList, x => x.fid === item.fid && x.eventTime === item.eventTime);
        if (type == "file") {
          this.localfileData = this.localfileList;
          if (this.localfileData.length == 0) {
            this.dialogVisible = false;
          }
        }
        if (type == "Forder") {
          let folderlist = this.localfileList;
          if (folderlist.length > 0) {
            this.localFolderData = this.buildForder(folderlist)

          } else {
            this.dialogVisible = false;
          }
          // this.localfileData = this.localfileList.filter(x => !x.folderName);
        }
        // 抛出事件，更新视图
        this.$EventBus.$emit("deletelocalfile", { data: item, type: "files" })

      }).catch(() => {
      });
    },
    // 删除项目
    btnDeleteLocalForder(item) {
      this.$confirm('此操作将永久删除该项目下所有文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        XEUtils.remove(this.localfileList, x => x.folderName === item.name);


        let folderlist = this.localfileList;
        if (folderlist.length > 0) {
          this.localFolderData = this.buildForder(folderlist)

        } else {
          this.dialogVisible = false;
        }
        // this.localfileData = this.localfileList.filter(x => !x.folderName);

        // 抛出事件，更新视图
        this.$EventBus.$emit("deletelocalfile", { data: item, type: "folders" })

      }).catch(() => {
      });

    }
  },
  mounted() {
    this.vegaInit();
  },

};
</script>
